import Axios, { AxiosResponse } from "axios";
import defineHeaderAxios from "@/utilities/useAuthToken";
import { Ref, ref } from "vue";
import { HistoricGpsPosition } from "../models/HistoricGpsPosition";
export default function (dateRange: string) {
    const logbookItems = ref<Array<HistoricGpsPosition>>([]);
    const get = async () => {
        await defineHeaderAxios();

        Axios.get(`/api/Alarm/geo/${dateRange}`)
            .then((result: AxiosResponse) => {
                if (result.status === 200) {
                    logbookItems.value = result.data;
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    get();
    return {
        logbookItems,
    };
}
